export default __webpack_public_path__ + "static/overview-401e328801a8785af5ae6b8780fbb46b.png";